import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from '../components/Dashboard/Dash';
import i18n from '../i18n';
import portal from "../target.json"
import { useDispatch } from 'react-redux';
import { setAppToken, setFullName, setPortal, setToken } from '../slices/authSlice';
import { parse as parseQuery } from 'query-string';
import { LSAuthorize } from '../Auth/LSAuthorize';
import { UserOnboard } from '../Auth/userOnboard/userOnboard';
import target from "../target.json";
import { MultiLocation } from '../components/selectLocation/multiLocation';
import LoginPage from '../Auth/components/LoginPage';
import { SignupPage } from '../Auth/components/signupPage';
import Magiclink from '../Auth/sso/magiclink';

const RouterInner = () => {

    const dispatch = useDispatch();
    const params = parseQuery(window.location.search);

    useEffect(() => {
        if (params && params.language) {
            i18n.changeLanguage(params.language);
        }

        if (portal.target) {
            if (portal.target !== "ls") {
                dispatch(setPortal(portal.target))
            } else {
                dispatch(setPortal("ls"))
            }

            if (params?.token) {
                dispatch(setToken(params?.token))
            }

            let name = ''

            switch (portal.target) {
                case "ls":
                    name = "PayEngine"
                    break
                case "epos":
                    name = "EposNow"
                    break
                case "revel":
                    name = "Revel"
                    break
                case "runit":
                    name = "Runit"
                    break
                case "mytime":
                    name = "MyTime"
                    break
                case "shift4":
                    name = "Shift4"
                    break
                default:
                    name = portal.target
            }

            dispatch(setFullName(name))

            document.title = name + " Accounting"
        }

        if (params?.appToken) {
            dispatch(setAppToken(params?.appToken))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Routes>
            <Route path="/:clientId/:locationId" element={<Magiclink />} />
            <Route path="/authorize-existing" element={<Magiclink />} />
            <Route path="/authorize" element={<LSAuthorize variant="authorize" />} />
            <Route path="/authorize-new" element={<LSAuthorize variant="authorize-new" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/user-onboard" element={<UserOnboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/select-location" element={<MultiLocation />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

const Router = () => (
    <BrowserRouter basename={target.basepath ?? ''}>
        <RouterInner />
    </BrowserRouter>
);

export default Router;
